export const VCC_ENTITY_TYPE = 'Variable Capital Companies';
export const VCC_ENTITY_TYPE_LOWER_CASE = 'variable capital companies';
export const VCC_ENTITY_TYPE_CODE = 'VC';
export const DEFAULT_KEY_WORD_MATCH_TYPE = 'NAME-CONTAINING';
export const DEFAULT_ISSUANCE_AGENCY = 'ACRA';
export const NON_ACRA_ISSUANCE_AGENCY = 'NON-ACRA';
export const ACRA = 'Accounting and Corporate Regulatory Authority';
export const ISSUANCE_AGENCY_ORDER = [
    'ACRA',
    'NON-ACRA',
    'ESG',
    'MCCY',
    'MOH',
    'ROS',
    'SLA',
    'MUIS',
    'MINDEF',
    'MDDI',
    'MOE',
    'MFA',
    'MLAW',
    'MOM',
    'MND',
    'MAS',
    'PA',
    'SNDGO',
    'MCI',
];
export const INDUSTRY_SELECTIONS = [
    {
        label: 'Wholesale trade',
        value: 'Wholesale trade',
    },
    {
        label: 'Financial service',
        value: 'Financial service',
    },
    {
        label: 'Management consultancy',
        value: 'Management consultancy',
    },
    {
        label: 'Software development',
        value: 'Software development',
    },
    {
        label: 'Retail trade',
        value: 'Retail trade',
    },
    {
        label: 'Information technology',
        value: 'Information technology',
    },
    {
        label: 'Food & beverage service',
        value: 'Food & beverage service',
    },
    {
        label: 'Construction',
        value: 'Construction',
    },
    {
        label: 'Education',
        value: 'Education',
    },
    {
        label: 'Online marketplaces',
        value: 'Online marketplaces',
    },
];
export const LIVE_COMPANY_ENTITY_STATUS = 'live company';
export const CONVERTED_TO_LLP_ENTITY_STATUS = 'converted to llp';
export const AMALGAMATED_ENTITY_STATUS = 'amalgamated';
export const GOOGLE_RECAPTCHA_TOKEN_HEADER = 'g-recaptcha-response';
export const MAXIMUM_FEDERATED_SEARCH_COUNT = 250;
export const LOCAL_STORAGE_FROM_INDUSTRY_DETAIL = 'fromIndustryDetail';
